import { ref, computed, watch } from '@vue/composition-api'
// import { title } from '@core/utils/filter'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import moment from 'moment-timezone'
import store from '@/store'
import router from '@/router'
import ability from '@/libs/acl/ability'
import { debounce } from 'lodash'
import useFilterCounter from '@/components/Filters/useFiltersCount'

export default function useList() {
  const refListTable = ref(null)

  const toast = useToast()

  store.dispatch('tenant/getAll')

  const tenantOptions = computed(() => store.getters['tenant/getSelectedItems'])
  const tenantFilter = ref(null)

  store.dispatch('router/getAll')
  const routerOptions = computed(() => store.getters['router/getSelectedItemsDescription'])

  if (router.currentRoute.params.id_tenant)
    tenantFilter.value = parseInt(router.currentRoute.id_tenant)

  const tableColumns = [
    { label: 'users_app.name', key: 'name', sortable: true },
    { label: 'users_app.first_name', key: 'first_name', sortable: true },
    { label: 'users_app.second_name', key: 'second_name', sortable: true },
    { label: 'users_app.email', key: 'email', sortable: false },
    { label: 'users_app.phone_number', key: 'phone_number', sortable: true },
    { label: 'router ', key: 'router.description', sortable: true },
    { label: 'users_app.particular_signs', key: 'senas_particulares', sortable: true },
    { label: 'users_app.height', key: 'estatura', sortable: true },
    { label: 'users_app.complexion', key: 'complexion.description', sortable: true },
    { label: 'users_app.lips', key: 'labios.description', sortable: true },
    { label: 'users_app.nose', key: 'nariz.description', sortable: true },
    { label: 'users_app.eye_size', key: 'tamano_ojos.description', sortable: true },
    { label: 'users_app.skin', key: 'tez.description', sortable: true },
    { label: 'users_app.hair_type', key: 'tipo_cabello.description', sortable: true },
    { label: 'users_app.age', key: 'edad.description', sortable: true },
    { label: 'users_app.face_type', key: 'tipo_cara.description', sortable: true },
    { label: 'users_app.photo', key: 'url', sortable: true },

  ]
  if (ability.can('update_users_app', 'UsersApp') == true || ability.can('delete_users_app', 'UsersApp') == true) {
    tableColumns.splice(0, 0, { label: 'actions.name', key: 'actions' })

  }

  const perPage = ref(10)
  const totalList = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    }
  })


  const fetchList = (ctx, callback) => {
    store.dispatch('user_app/getAll', {
      q: searchQuery.value,
      max: perPage.value,
      'page[n]': currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      id_tenant: tenantFilter.value,
    })
      .then(response => {
        callback(response.data)
        totalList.value = response.meta.total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error obteniendo la información',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const formatDateAssigned = value => {
    const formattedDate = moment(value).format('DD/MM/YYYY HH:mm:ss')
    return formattedDate
  }

  const refetchData = () => {
    refListTable.value.refresh()
  }

  watch([currentPage, perPage], () => {
    refetchData()
  })

  watch([searchQuery], debounce(() => {
    refetchData()
  }, 500))

  // filters counter ============================
  const filters = ref({});
  const filtersCount = useFilterCounter(filters);
  const buildFilters = () => {
    filters.value = {
      id_tenant: tenantFilter.value,
    };
    refetchData();
  }
  const clearSearchFilters = () => {
    tenantFilter.value = null;
    buildFilters();
  }
  // ============================================

  return {
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    formatDateAssigned,
    tenantOptions,
    tenantFilter,
    refetchData,
    routerOptions,
    buildFilters,
    clearSearchFilters,
    filtersCount,
  }
}
